import { Upload } from 'antd';
import styled from 'styled-components';
import { pickThemeColor } from '@/theme';

export const StyledDragger = styled(Upload.Dragger)`
  &.ant-upload-wrapper {
    & .ant-upload-drag .ant-upload {
      padding: 2rem 1.5rem;
      border: 1px dashed ${pickThemeColor('DIVIDER')};
      border-radius: 0.5rem;
    }
    .ant-upload-drag-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }

    & .ant-upload.ant-upload-drag {
      background: ${pickThemeColor('BG_SECONDARY')};
      border: none;
    }
  }
`;

export const StyledUploadSelect = styled(Upload)`
  .ant-upload-drag {
    .ant-upload {
      padding: 0;
    }

    display: block;
    background-color: transparent;
    border: none;
    text-align: initial;
  }
`;
